const axios = require("axios")
import { lalaMallApi } from '@/utils/config'

const api = {
    addClue(params={}) {
        const url = `${lalaMallApi}/sales/leads/add`
        return axios.post(url, params)
    },
    getCaptcha(phone) {
        const url = `${lalaMallApi}/sms/sendCode/v2`
        return axios.get(url, {
            params: {
                phone,
                tt: Date.now()
            }
        })
    }
}

export default api